import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Photo } from '../entities/files/files.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class PhotosHttpService extends ApiService {
  getAllPhotos(modelId: number): Observable<Photo[]> {
    return this.http.get<Photo[]>(`${this.api}/models/${modelId}/images`);
  }

  generatePhotoBundle(folderName: string, photos: Photo[]) {
    const imageNames = photos.map((photo) => photo.name);
    const url = `${this.api}/models/generate-photo-bundle`;
    return this.http.post(url, { folderName, imageNames });
  }
}
